import { useQuery } from '@tanstack/react-query';

import { type AnalyticsSearchStatsParams, getAnalyticsSearchStats } from '~/services/AnalyticsService';

import { analyticsQueryKeys } from './analyticsQueryKeys';

export function useGetAnalyticsSearchStats(params: AnalyticsSearchStatsParams | null) {
  const query = useQuery({
    queryKey: params ? analyticsQueryKeys.stats(params) : analyticsQueryKeys.statsIdle(),
    queryFn: async ({ signal }) => getAnalyticsSearchStats(params!, { signal }),
    enabled: params !== null,
    retry: false,
  });

  return { data: query.data, isFetching: query.isFetching, error: query.error, refetch: query.refetch };
}
